import { render, staticRenderFns } from "./AssignCertificate.vue?vue&type=template&id=7c586418&"
import script from "./AssignCertificate.vue?vue&type=script&lang=js&"
export * from "./AssignCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports